import SALink from 'components/SALink'
import React, { FC } from 'react'
import styles from './LegalDisclaimer.module.scss'
import classNames from 'classnames'
import FormCheckbox from '../FormElements/Checkbox'

type TermsMessageProps = {
  customTermsStyles?: string
}

type LegalDisclaimerProps = {
  isConsentRequired: boolean
  isChecked?: boolean
  onClick?: () => void
  name?: string
  customTermsStyles?: string
  customStyles?: string
  isHidden?: boolean
}

const TermsMessage: FC<TermsMessageProps> = ({ customTermsStyles }) => (
  <p className={classNames(styles.terms, customTermsStyles)} data-type='terms-message'>
    I agree to receive marketing emails from Saatchi Art about products that may be of interest to
    me. By subscribing, I also agree to the{' '}
    <SALink
      data-style='link'
      href='https://www.saatchiart.com/terms'
      rel='noopener noreferrer'
      target='_blank'
    >
      Terms of Use
    </SALink>{' '}
    and acknowledge that my information will be used as described in the{' '}
    <SALink
      data-style='link'
      href='https://www.saatchiart.com/privacy'
      rel='noopener noreferrer'
      target='_blank'
    >
      Privacy Notice
    </SALink>
  </p>
)

const LegalDisclaimer: FC<LegalDisclaimerProps> = ({
  isConsentRequired,
  customTermsStyles,
  customStyles,
  onClick,
  isChecked,
  name = 'newsletterConsent',
  isHidden,
}) => {
  if (isHidden) {
    return null
  }

  if (isConsentRequired) {
    return (
      <FormCheckbox
        name={name}
        checked={isChecked}
        onClick={onClick}
        customLabelStyle={classNames(styles.newsletterLabel, customStyles)}
      >
        <TermsMessage customTermsStyles={customTermsStyles} />
      </FormCheckbox>
    )
  }

  return <TermsMessage customTermsStyles={customTermsStyles} />
}

export default LegalDisclaimer
